import { Form, Field, TextInput } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { SupplierCertificateField } from './SupplierCertificateField';
import { DateOfDispatchField } from '@/components/common';

/**
 * Props:
 *   setValue  (name, value) => void — for the Reference ID Generate button
 */
export const SustainabilityDeclarationDetailsSection = ({ setValue }) => {
  const t = useTranslations();

  return (
    <Form.Section title={t('SECTION_SUSTAINABILITY_DECLARATION_DETAILS')}>
      <Form.Row columns={1}>
        <Field name="declarationNo" required>
          {({ id, name, value, onChange, onBlur, status, message, required }) => (
            <TextInput
              id={id}
              name={name}
              label={t('FIELD_DECLARATION_NO')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
              required={required}
            />
          )}
        </Field>
      </Form.Row>

      <Form.Row columns={2}>
        <Field name="dateOfIssuance" required>
          {({ id, name, value, onChange, onBlur, status, message, required }) => (
            <TextInput
              id={id}
              name={name}
              // TODO: swap for a DatePicker when the library has one.
              type="date"
              label={t('DECLARATIONS_COL_DATE_OF_ISSUANCE')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
              required={required}
            />
          )}
        </Field>

        <DateOfDispatchField />
      </Form.Row>

      <Form.Row columns={1}>
        <SupplierCertificateField setValue={setValue} />
      </Form.Row>
    </Form.Section>
  );
};
